import React from 'react';
import { AlertModel as ModelFactory } from '@leverege/recovr-models';
import { capitalize } from '@leverege/string-util';
import { Checkbox } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { getModelFromFactory } from '../../../util/Model';
import { jsx as _jsx } from "react/jsx-runtime";
export default function GroupCheckboxEditor(props) {
  const {
    valueKey,
    label,
    value,
    loading
  } = props;
  const Model = getModelFromFactory(ModelFactory);
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsx(Checkbox, {
    disabled: loading,
    label: label,
    onChange: onModelChange,
    eventData: `set${capitalize(valueKey)}Active` // TODO: fix suffix overfit
    ,
    value: Model[`get${capitalize(valueKey)}Active`](value)
  }, valueKey) // TODO: fix suffix overfit
  ;
}